import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext } from 'react';
import { Form } from 'semantic-ui-react';
import _startCase from 'lodash/startCase';
import { validateFormField } from './MultiSelectField.utils';
import { FormFieldPropType } from '../../../../../types/FormField.types';
import { DynamicFormContext } from '../../../context/DynamicFormContext';
import { getSelectOptions } from '../DynamicFormFields/DynamicFormFields.utils';
function MultiSelectField(_ref) {
  var field = _ref.field,
    value = _ref.value;
  var _useContext = useContext(DynamicFormContext),
    hideLabels = _useContext.hideLabels,
    isFormDisabled = _useContext.isFormDisabled,
    onChange = _useContext.onChange,
    formErrors = _useContext.formErrors,
    setFormErrors = _useContext.setFormErrors,
    clearFieldError = _useContext.clearFieldError,
    displayErrors = _useContext.displayErrors;
  var label = field.label,
    name = field.name,
    placeholder = field.placeholder,
    required = field.required,
    options = field.options,
    disabled = field.disabled;
  var updatedOptions = getSelectOptions(options);
  function handleChange(e, _ref2) {
    var fieldName = _ref2.name,
      fieldValue = _ref2.value;
    clearFieldError(name);
    onChange(e, {
      name: fieldName,
      value: fieldValue
    });
    var error = validateFormField(field, fieldValue);
    if (error) {
      setFormErrors(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), error);
      });
    }
  }
  return /*#__PURE__*/React.createElement(Form.Dropdown, {
    fluid: true,
    multiple: true,
    selection: true,
    disabled: isFormDisabled || disabled,
    error: displayErrors && formErrors[name],
    required: required,
    name: name,
    label: hideLabels ? null : _startCase(label),
    placeholder: placeholder,
    value: value || [],
    labeled: false,
    options: updatedOptions,
    onChange: handleChange
  });
}
export default MultiSelectField;